<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="ORIM-Book-Title"><span class="CharOverride-2">The Bayou </span>Strangler</p>
<p class="ORIM-Book-Subtitle">Louisiana’s Most Gruesome Serial Killer</p>
<p class="ORIM-Author-Name">Fred Rosen</p>
<p class="ORIM-Book-Subtitle"><img alt="" src="image/logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Rosen_BayouStrangler_4P-1.vue?e2379fe8